"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FolderPage = void 0;
const react_1 = require("react");
const react_router_1 = require("react-router");
const FolderPage = (props) => {
    const history = (0, react_router_1.useHistory)();
    const parent = props.data.parentLink.url;
    const parentUrl = new URL(parent);
    (0, react_1.useEffect)(() => {
        parentUrl.search = location.search;
        history.push(`${parentUrl.pathname}${parentUrl.search}`);
    }, []);
    return null;
};
exports.FolderPage = FolderPage;
exports.default = exports.FolderPage;
